import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgWizardService } from 'ng-wizard';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { XlsxViewComponent } from 'src/app/shared/xlsx-view/xlsx-view.component';
import { ExcelModel, GeographyModel } from "../../shared/models/geography";
import { XlsxService } from 'src/app/services/xlsx/xlsx.service';
import { HttpEventType } from '@angular/common/http';

@Component({
  selector: 'app-apptakeover-whitelist',
  templateUrl: './apptakeover-whitelist.component.html',
  styleUrls: ['./apptakeover-whitelist.component.scss']
})
export class ApptakeoverWhitelistComponent implements OnInit {

  @Input() whitelistObj = {};
  @Input() zoneData:any =[];

  @Output() whiteListed: EventEmitter<boolean> = new EventEmitter;
  @ViewChild('RejectedData', { static: false }) RejectedPopup: TemplateRef<any>

  whitelistUser : any = [];
  filteredDetails: any = []

  page = 1;
  responseData:any = [];

  excelFormat: any = {};
  excelArray: any = [];
  excelData: any = [];
  commonSearch : any = "";
  zoneId:any = ""
  region_id :any = []
  state_id :any = []
  city_id :any = [] 
  localData: any;
  dropdownSettings = {};
  tempOptionModel: any;
  excel: ExcelModel = new ExcelModel();
  excelFile: any;

  constructor(
    private router: Router,
    private exportExcelService: ExportExcelService,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private toast : ToastClientService,
    private modalService: NgbModal,
    private xlsx: XlsxService,
  ) { 
    this.localData = JSON.parse(localStorage.getItem('appTakeoverList'))
    // this.zoneId = this.localData.zone_id != null ? this.localData.zone_id : ""
  }

  ngOnInit() {
    this.fetchZoneTypeData(this.localData.whitelisting_type)
    if(this.localData.id){
      this.getWhitelistUser();
    }

    this.dropdownSettings = {
      singleSelection: false,
      text: "Select",
      selectAllText: "Select All",
      unSelectAllText: "Unselect All",
      enableSearchFilter: true,
      classes: "myclass custom-class"
    };
  }

  

  filter(){
    this.getWhitelistUser()
  }
  reset(){
    this.commonSearch = ''
    this.getWhitelistUser()
  }

  getZoneId(e){
    // console.log(e.target.value);
    this.zoneId = e.target.value
  }

  selectedItem(eve) {
    this.formateFillters(eve, "id");
    console.log(eve)
    //
  }

  formateFillters(data, name) {

  if (!this.filteredDetails[name]) {
    this.filteredDetails[name] = [];
  }

  if (data.status == "singleSelect") {

    const exists = this.filteredDetails[name].includes(data.data.id);

    if (!exists) {
      this.filteredDetails[name].push(data.data.id);
    }

  } 
  else if (data.status == "singleDeselect") {

    this.filteredDetails[name] =
      this.filteredDetails[name].filter(x => x !== data.data.id);

  } 
  else if (data.status == "SelectAll") {

    this.filteredDetails[name] = data.data.map(x => x.id);

  } 
  else if (data.status == "unSelectAll") {

    this.filteredDetails[name] = [];
  }

  return this.filteredDetails[name];
}

  WhitelistingUsers(){
    console.log(this.localData);

    let payload;

    if(this.localData.whitelisting_type == 4){
      payload = new FormData();
      payload.append('config_id',this.localData.id);
      payload.append('excel_file', this.excelFile);

      this.apiService.upload(this.apiConfig.whitelistuser, payload).subscribe((res:any)=>{
        if (res.type === HttpEventType.Response) {

            console.log(res.body);

            if (res.body.data) {
              this.closeoptionModel()
              if(res.body.data.rejected_count != 0){
                this.responseData = res.body.data.rejectedData
                this.toast.Error(res.body.data.message)
                this.modalService.open(this.RejectedPopup, { centered: true, size: 'lg', backdrop: false })
              }else{
                this.toast.Success(res.body.data.message);
                this.getWhitelistUser();
              }
            }
          }
      })
    }else{
      payload = {
        config_id : this.localData.id,
        ids : this.filteredDetails.id ? this.filteredDetails.id.toString() : "",
      }

      this.apiService.post(this.apiConfig.whitelistuser, payload).subscribe((res:any)=>{
        if(res.status == 200){
          this.toast.Success(res.body.data.message)
          this.getWhitelistUser();
        }
      })
    }
  }

  fetchZoneTypeData(zone_type){
    if(zone_type==1){
      this.apiService.get(this.apiConfig.configGetRegion).subscribe((res)=>{
        this.zoneData = res['data'].region
         const selectedIds = this.localData.region_id || [];

          this.region_id = this.zoneData.filter(x =>
            selectedIds.includes(x.id)
          );

          console.log("regionData",this.region_id);
        
        console.log("regionData",this.zoneData);
      })
    }else if(zone_type==2){
      this.apiService.get(this.apiConfig.configGetStates).subscribe((res)=>{
        this.zoneData = res['data'];
        const selectedIds = this.localData.state_id || [];

          this.state_id = this.zoneData.filter(x =>
            selectedIds.includes(x.id)
          );

          console.log("stateData",this.state_id);
        console.log("StateData",this.zoneData);
      })
    }else{
      this.apiService.get(this.apiConfig.configGetCities).subscribe((res)=>{
        this.zoneData = res['data'].cities;
        // const selectedIds = this.localData.city_id || [];

        const selectedIds = (this.localData.city_id || '').toString();

        const selectedSet = new Set(
          selectedIds.split(',').map(id => id.trim())
        );

        this.city_id = this.zoneData.filter(x =>
          selectedSet.has(String(x.id))
        );

          console.log("cityData",this.city_id);
        console.log("cityData",this.zoneData);
      })
    }
}


  getWhitelistUser(){
    this.excelArray = [];
    this.excelData = [];
    this.apiService.getHeaders(this.apiConfig.getWhitelistedUser + `?&config_id=${this.localData.id}&search=${this.commonSearch}`).subscribe((res : any)=>{
      console.log(res)
      this.whitelistUser = res.body.data.users;
      console.log(this.whitelistUser);
      //2) for excelData
      this.excelData = res.body.data.users;
 
    })
  }

  showuploadTemplateModal(targetModal) {
    this.tempOptionModel = this.modalService.open(targetModal, {
      centered: true,
      // backdrop: 'static'
    });
  }

  closeoptionModel() {
      this.tempOptionModel.close();
    }

    uploadXlsx(eve) {
      if (eve.target.files) {
        this.excelFile = eve.target.files[0];
        this.WhitelistingUsers()
      }
      // this.xlsx.uploadXlsx(eve).then((res) => {
      //   this.xlsxView(res);
      // });
    }
    xlsxView(data) {
      this.closeoptionModel();
      let modalRef = this.modalService.open(XlsxViewComponent, {
        centered: true,
        backdrop: "static",
        size: "xl",
        scrollable: true,
        windowClass: "ExcelTemplateViewModal",
      });
      modalRef.componentInstance.xlsxDatas = data;
      modalRef.result.then(
        (result) => {
          console.log("XlsxViewComponent::", result);
          if (result.length > 0) {
            this.excel.excel_data = result;
            console.log(this.excel.excel_data);
            
          }
        },
        (reason) => { }
      );
    }
  

  downloadExcel() {
    let header = ["Mobile_Number"]
    let filename = "whitelist_user_template"
    this.exportExcelService.commonPrintHeadersTwo(header, filename, 'users')
  }

  paginationClick(e) {
    console.log(e);
    this.page = e;
    this.getWhitelistUser();
  }

  submit(){
   this.whiteListed.emit(true)
  }

  toggleStatus(user){
    console.log(this.whitelistUser);
    console.log(user);
    
    let payload = {
      engagement_id: this.localData.engagement_type_id,
      id: user.id,
      status : user.status == 0 ? 1 : 0
    }
    this.apiService.post(this.apiConfig.disableEngagement,payload).subscribe((res : any)=>{
      if(res.status ==200){
        this.toast.Success(res.body.data)
      }else{
        this.toast.Error(res.body.data)
      }
      this.getWhitelistUser();
    })
  }




}
